import { Button } from 'react-bootstrap'
import { Plus } from 'lucide-react'

export default function AddButton(props) {

    const { button_name, onClick } = props

    return (
        <>
            <Button
                type='button'
                size='sm'
                className='d-flex align-items-center justify-content-center gap-2 create_btn ms-1'
                onClick={onClick}
            >
                <Plus size={20} />
                {button_name}
            </Button>
        </>
    )
}
